export default __webpack_public_path__ + "static/media/cocktails4.4b50d3c8.jpg";